import { IconButton } from '@/components/ui/button'
import { DollarSign, Trash, UserKey } from 'lucide-react'
import { memo } from 'react'

export const PayButton = memo(({ onClick }: { onClick: () => void }) => (
  <IconButton
    className="h-8 w-10"
    variant="primary"
    title="Abonar"
    onClick={(e) => {
      e.stopPropagation()
      onClick()
    }}
  >
    <DollarSign className="h-4 w-4" />
  </IconButton>
))

export const DeleteButton = memo(({ onClick }: { onClick: () => void }) => (
  <IconButton
    className="h-7 w-7"
    onClick={(e) => { e.stopPropagation(); if (confirm('¿Está seguro de eliminar el cargo pendiente?')) onClick() }}
    variant="danger"
  >
    <Trash className="h-3.5 w-3.5" />
  </IconButton>
))

export const CollectorActionButton = memo(({ onClick }: { onClick: () => void }) => (
  <IconButton
    variant="warning"
    className="h-7 w-7"
    title="Acción con cobrador"
    onClick={(e) => { e.stopPropagation(); onClick() }}
  >
    <UserKey className="h-3.5 w-3.5" />
  </IconButton>
))
